import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';


const API_URI = process.env.REACT_APP_API_URI || 'http://localhost:5000';
const CloudUrl = process.env.REACT_APP_CLOUD_FLARE_URL;


const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [visibleProjects, setVisibleProjects] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};

    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_URI}/api/portfolio`, { headers: authHeaders });

        const fetchedProjects = response.data.map(project => ({
          id: project._id,
          title: project.title,
          description: project.description,
          imageUrl: project.images && project.images.length
            ? `${CloudUrl}/${project.images[0]}`
            : '',
          link: `/project/${project._id}`,
        }));

        setProjects(fetchedProjects);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setError('Failed to load projects.');
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [token]); 

  const handleShowMoreProjects = () => {
    setVisibleProjects(prevVisibleProjects => prevVisibleProjects + 10);
  };

  if (loading) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex items-center justify-center">
        <p className="text-xl">Loading projects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex flex-col items-center justify-center">
        <p className="text-xl mb-4">{error}</p>
        <button
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="bg-black text-white p-8 min-h-screen flex items-center justify-center">
        <p className="text-xl">No projects available at the moment. Please check back later!</p>
      </div>
    );
  }

  return (
    <div className="bg-black text-white p-8 min-h-screen">
      <h1 className="text-5xl md:text-6xl font-bold mb-8 text-center">Portfolio</h1>
      <div className="space-y-8">
        {projects.slice(0, visibleProjects).map((project, index) => (
          <div
            key={project.id}
            className={`flex flex-col md:flex-row ${index % 2 === 0 ? '' : 'md:flex-row-reverse'} items-center`}
          >
            <Link to={project.link} className="w-full md:w-1/3 group">
              <div className="relative overflow-hidden w-full h-64 mb-4 md:mb-0">
                {project.imageUrl ? (
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="absolute inset-0 w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                  />
                ) : (
                  <div className="absolute inset-0 bg-gray-800 flex items-center justify-center">
                    <span className="text-gray-500">No Image Available</span>
                  </div>
                )}
              </div>
            </Link>
            <div className="md:w-2/3 p-4">
              <Link to={project.link}>
                <h2 className="text-3xl md:text-4xl font-bold hover:text-green-500 transition-all duration-700 hover:underline">
                  {project.title}
                </h2>
              </Link>
              <Link to={project.link}>
                <p className="mt-2 text-lg md:text-xl hover:text-green-500 transition-all duration-700 hover:underline">
                  {project.description}
                </p>
              </Link>
              <Link to={project.link} className="text-green-500 hover:underline transition-all duration-700 mt-4 inline-block">
                Read More
              </Link>
            </div>
          </div>
        ))}
      </div>
      {visibleProjects < projects.length && (
        <div className="text-center mt-8">
          <button
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded transition-all duration-700"
            onClick={handleShowMoreProjects}
          >
            Show More Projects
          </button>
        </div>
      )}
    </div>
  );
};

export default Portfolio;


